<h1 mat-dialog-title>Passwort ändern</h1>
<mat-dialog-content>

  <form (keyup.enter)="changePassword()" (ngSubmit)="changePassword()" tabindex="0" [formGroup]="passwordFormGroup">

    <br>

    Bitte geben Sie Ihr aktuelles Passwort ein. <br><br>

    <mat-form-field appearance="outline">
      <mat-label>Aktuelles Passwort</mat-label>
      <input [type]="hideCurrentPw ? 'password' : 'text'" formControlName="currentPassword" matInput placeholder=""
             required autocomplete="current-password">
      <mat-icon (click)="hideCurrentPw = !hideCurrentPw"
                matSuffix>{{ hideCurrentPw ? 'visibility_off' : 'visibility' }}
      </mat-icon>
    </mat-form-field>

    <br><br>

    Tragen Sie folglich das neue Passwort in beide untenstehende Felder ein.<br><br>

    <li class="mat-form-field--inline">
      <mat-form-field appearance="outline" style="margin-right:16px">
        <mat-label>Neues Passwort</mat-label>
        <input [type]="hideNewPw ? 'password' : 'text'" formControlName="newPassword" matInput placeholder="" required
               autocomplete="new-password">
        <mat-icon (click)="hideNewPw = !hideNewPw" matSuffix>{{ hideNewPw ? 'visibility_off' : 'visibility' }}</mat-icon>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Passwort wiederholen</mat-label>
        <input [type]="hideNewPw ? 'password' : 'text'" formControlName="newPasswordRepeated" matInput placeholder=""
               required autocomplete="new-password">
        <mat-icon (click)="hideNewPw = !hideNewPw" matSuffix>{{ hideNewPw ? 'visibility_off' : 'visibility' }}</mat-icon>
      </mat-form-field>
    </li>

    Sie müssen sich anschließend mit Ihrem neuen Passwort erneut anmelden!

    <br>
    <br>

  </form>

</mat-dialog-content>
<mat-dialog-actions class="mat-dialog-buttons">
  <button (click)="close()" mat-button mat-raised-button>Abbrechen</button>
  <button (click)="changePassword()" color="primary" mat-button mat-raised-button>Speichern</button>
</mat-dialog-actions>
